"use client";

import {
  getTranslatedProductDescription,
  getTranslatedProductName,
} from "@/app/directories/shop/helper";
import { useEffect, useRef, useState } from "react";
import { CategoryTreatmentWrapper } from "./CategoryTreatmentWrapper";

export const CategoryGrid = ({
  sortedProductsByPopularity,
  clientSlug,
  priceToggleColor,
  category,
  orgId,
  languageCode,
}) => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollWidth = container.scrollWidth - container.clientWidth;
      const scrolled = container.scrollLeft;
      const progress = (scrolled / scrollWidth) * 100;
      setScrollProgress(progress);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      id={`category-${category.id}`}
      className="flex flex-col lg:py-20 lg:pt-20 sm:py-10 sm:pt-5 w-full lg:px-[12rem] sm:px-0 lg:gap-20 sm:gap-8 sm:border-b-0 lg:border-b border-b-[#e1e1e1]"
    >
      <p className="config-h3 lg:text-[36px] sm:!text-3xl font-light lg:px-0 sm:px-4">{`${category.name.toUpperCase()}`}</p>
      <div
        ref={containerRef}
        key={`${category.id}`}
        className="sm:px-4 lg:px-0 sm:flex sm:flex-row sm:overflow-x-scroll lg:grid lg:grid-cols-2 lg:gap-14 sm:gap-4 no-scrollbar"
      >
        {sortedProductsByPopularity.map((product, index) => (
          <div
            key={`category-section-${product.id}`}
            className="sm:w-[240px] sm:flex-none lg:w-full"
          >
            <CategoryTreatmentWrapper
              product={product}
              hrts={product.productToHrt}
              description={getTranslatedProductDescription(
                product,
                languageCode,
              )}
              name={getTranslatedProductName(product, languageCode)}
              productId={product.id.toString()}
              clientSlug={clientSlug}
              priceToggleColor={priceToggleColor}
              displayMode={"grid"}
              orgId={orgId}
            />
          </div>
        ))}
      </div>

      <div
        key={`${category.id}-scroll`}
        className="lg:hidden sm:block w-[calc(100%-32px)] ml-4 h-1 bg-[#c2c2c2] rounded-full overflow-hidden"
      >
        <div
          className="h-full bg-black transition-all duration-300 ease-out rounded-full"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>
    </div>
  );
};
